export default __webpack_public_path__ + "static/media/MHNLogo2.0e27f6e9.png";